<template>
  <div>
    <!-- PANTALLA DE BIENVENIDA / WELCOME MODAL -->
    <transition name="fade">
      <div v-if="mostrarWelcome" class="welcome-overlay">
        <div class="welcome-card">
          <p class="welcome-texto">
            Bienvenidos a nuestra invitación
          </p>
          <img src="@/assets/INICIALES.png" alt="Iniciales" class="welcome-logo" />
          <button class="welcome-btn" @click="ingresarInvitacion">
            Ingresar
          </button>
        </div>
      </div>
    </transition>

    <!-- SECCIÓN PRINCIPAL PORTADA -->
    <transition name="fade">
      <div v-if="isVisible" class="fotoportada-container" ref="portadaRef">
        <img
          src="@/assets/principal.webp"
          alt="Imagen de portada"
          class="fotoportada-img"
          ref="imagenPortada"
          loading="eager"
          decoding="async"
          fetchpriority="high"
        />

        <div class="overlay">
          <button class="hamburger" aria-label="Menú">
            <span></span><span></span><span></span>
          </button>
          <div class="texto-inferior" ref="textoInferiorRef"><br><br><br>
            <!-- LOGO EN REEMPLAZO DE LOS NOMBRES -->
            <img src="@/assets/INICIALES.png" alt="Logo" class="logo-portada" />
          </div>
        </div>

        <div class="footer-bar">
          <div class="footer-text">14/Noviembre/2026.
   
<br /> Tecuala, Nayarit.</div>
          <div class="footer-menu"><i class="fas fa-bars"></i></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'PortadaBodaElegante',
  props: {
    nombresLinea: { type: String, default: 'Karla y Jesús' },
    fechaLinea:   { type: String, default: '14 de Noviembre de 2026' }
  },
  setup () {
    const mostrarWelcome = ref(true)
    const isVisible = ref(true)
    const portadaRef = ref(null)
    const imagenPortada = ref(null)
    const textoInferiorRef = ref(null)

    const animarTexto = () => {
      if (!textoInferiorRef.value) return
      gsap.from(textoInferiorRef.value.children, {
        y: 22,
        opacity: 0,
        duration: 0.9,
        stagger: 0.12,
        ease: 'power3.out'
      })
    }

    const ingresarInvitacion = () => {
      mostrarWelcome.value = false
      nextTick(() => {
        animarTexto()
      })
    }

    onMounted(() => {
      nextTick(() => {
        if (imagenPortada.value?.src) {
          const preload = new Image()
          preload.src = imagenPortada.value.src
        }
      })
    })

    onBeforeUnmount(() => {
      if (textoInferiorRef.value) gsap.killTweensOf(textoInferiorRef.value.children)
    })

    return {
      mostrarWelcome,
      isVisible,
      portadaRef,
      imagenPortada,
      textoInferiorRef,
      ingresarInvitacion
    }
  }
}
</script>

<style scoped>
/* =========================
   FUENTES
========================= */
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600&family=Great+Vibes&display=swap');


/* =========================
   TRANSICIONES
========================= */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


/* =========================
   PANTALLA BIENVENIDA (WELCOME)
========================= */
.welcome-overlay {
  position: fixed;
  inset: 0;
  background-color: #F4F1E9;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}
.welcome-card {
  background: #F4F1E9;
  padding: 40px 25px;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  text-align: center;
  max-width: 420px; /* Aumentado para dar suficiente espacio horizontal */
  width: 90%;
}

.welcome-texto {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  color: #333333;
  line-height: 1.5;
  margin-bottom: 20px;
  white-space: nowrap; /* Fuerza a que todo el texto quede en una sola línea */
}

/* Ajuste responsivo para celulares pequeños */
@media (max-width: 400px) {
  .welcome-texto {
    font-size: 15px; /* Reduce un poco la letra para que quepa completa en pantallas reducidas */
  }
}

.welcome-texto {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  color: #333333;
  line-height: 1.5;
  margin-bottom: 15px;
}

.welcome-logo {
  max-width: 110px;
  height: auto;
  display: block;
  margin: 0 auto 25px auto;
}

.welcome-btn {
background: #686D55; color: #F4F1E9; 
  border: none;
  padding: 12px 36px;
  font-size: 15px;
  border-radius: 25px;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.welcome-btn:hover {
  background-color: #1a1a1a;
  transform: scale(1.02);
}


/* =========================
   CONTENEDOR PORTADA
========================= */
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
   background-color: #F4F1E9; ; 

  overflow: hidden;
}

.fotoportada-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  will-change: auto;
}


/* =========================
   OVERLAY OSCURO CON SOMBRA SUPERIOR
========================= */
.overlay {
  position: absolute;
  inset: 0;
  /* Sombra oscura arriba para resaltar el logo blanco */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0.05) 100%);
  z-index: 2;
}


/* =========================
   BOTÓN HAMBURGUESA
========================= */
.hamburger {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 22px;
  display: grid;
  gap: 5px;
  background: transparent;
  border: 0;
  padding: 0;
  z-index: 3;
}

.hamburger span {
  display: block;
  height: 2px;
  background: #fff;
  border-radius: 1px;
}


/* =========================
   TEXTO Y LOGO SUPERIOR
========================= */
.texto-inferior {
  position: absolute;
  left: 0;
  right: 0;
  top: 15px;
  text-align: center;
  padding: 0 14px;
  z-index: 3;
}

/* LOGO BLANCO DE LA PORTADA */
.logo-portada {
  max-width: 120px;
  height: auto;
  margin-top: -70px;
  margin-bottom: 12px;
  /* Convierte la imagen negra en blanco puro */
  filter: brightness(0) invert(1) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  display: inline-block;
}

.script-fecha {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 3.6vw, 18px);
  letter-spacing: 2.5px;
  color: #fff;
  margin: 0;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}


/* =========================
   FOOTER
========================= */
.footer-bar {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 54px;
  background-color: #4a4d3d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: #fff;
  font-family: 'Playfair Display', serif;
  font-size: 11px;
  letter-spacing: 1px;
  z-index: 4;
}

.footer-text {
  line-height: 1.2;
  text-align: left;
}

.footer-menu {
  font-size: 18px;
}
</style>